module.exports = __webpack_public_path__ + "static/media/26.03de1559.jpg";